import React from 'react';
import '../../App.css';

const SettingsSwitch = ({ checked, onChange }) => (
  <div className={`settings-switch ${checked ? 'active' : ''}`} onClick={() => onChange(!checked)}>
    <div className="settings-switch-thumb" />
  </div>
);

export default SettingsSwitch;
